/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {InlineObject} from '../models/InlineObject';

export interface ApproveRequest$Request {
    requestId: string;
}

export interface ApproveRequest$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const approveRequestRequest = createAction<PayloadData<void, ApproveRequest$Request>>('APPROVAL_REQUEST__APPROVE_REQUEST__REQUEST');
export const approveRequestSuccess = createAction<PayloadData<void, ApproveRequest$Request>>('APPROVAL_REQUEST__APPROVE_REQUEST__SUCCESS');
export const approveRequestFailure = createAction<PayloadData<Error, ApproveRequest$Request, true>>('APPROVAL_REQUEST__APPROVE_REQUEST__FAILURE');

export const approveRequestActions = [
    approveRequestRequest,
    approveRequestSuccess,
    approveRequestFailure
] as const;

/**
 * Approve an approval request by ID.
 * @param {string} meta.requestId The ID of the approval request to be approved.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const approveRequest = (meta: ApproveRequest$Request, config?: ApproveRequest$Config) => {
    return {
        CALL_API: {
            types: approveRequestActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/approval/requests/${meta.requestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeclineRequest$Request {
    requestId: string;
    inlineObject: InlineObject;
}

export interface DeclineRequest$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const declineRequestRequest = createAction<PayloadData<void, DeclineRequest$Request>>('APPROVAL_REQUEST__DECLINE_REQUEST__REQUEST');
export const declineRequestSuccess = createAction<PayloadData<void, DeclineRequest$Request>>('APPROVAL_REQUEST__DECLINE_REQUEST__SUCCESS');
export const declineRequestFailure = createAction<PayloadData<Error, DeclineRequest$Request, true>>('APPROVAL_REQUEST__DECLINE_REQUEST__FAILURE');

export const declineRequestActions = [
    declineRequestRequest,
    declineRequestSuccess,
    declineRequestFailure
] as const;

/**
 * Reject an approval request by ID.
 * @param {string} meta.requestId The ID of the approval request to be rejected.
 * @param {InlineObject} meta.inlineObject
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const declineRequest = (meta: DeclineRequest$Request, config?: DeclineRequest$Config) => {
    return {
        CALL_API: {
            types: declineRequestActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/approval/requests/${meta.requestId}`,
            TRANSPORT_REQUEST_BODY: meta.inlineObject,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

